import React from 'react'
import CryptoPayoutFeeGroupsContainer from 'containers/panel/admin/crypto-payout-fee-groups-container'

const AdminCryptoPayoutFeeGroupsPage = () => {
  return <CryptoPayoutFeeGroupsContainer />
}

export default AdminCryptoPayoutFeeGroupsPage